var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.intensity > 0)?_c('div',{staticClass:"cherry-blossoms-overlay"},_vm._l((_vm.activePetals),function(petal,index){return _c('div',{key:`petal-${index}`,staticClass:"cherry-petal",style:(_vm.getPetalStyle(petal))},[_vm._v(" 🌸 ")])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }